import { httpClient } from "./http-client";
const API_HOST = process.env.VUE_APP_CORE_API_HOST;

class AuthService {
    constructor() { }
    async get_refresh_token(req = {}) {
        return httpClient({
            url: `token/lifetime/extend/?`,
            baseURL: API_HOST,
            method: "post",
            data: { redirect_uri: location.origin + '/auth/callback' },
            headers: req.headers
        });
    }
}
export const authService = new AuthService();